import styleInject from '../../node_modules/style-inject/dist/fb3a8d84bb477a96e56a5e12f7d7ac81b9d9799a9277fe852d93ab86a1b81224.cfe-internal.js';

var css_248z = "._1XD-V{position:relative}._3_Wt7{opacity:0;position:absolute;height:36px;width:100%;left:0;z-index:-1}._1AFLk{margin-left:16px;font-size:14px;color:#32363a}._1AFLk ._3VQE8{margin-right:16px}";
var filePickerStyles = {"container":"_1XD-V","fileInput":"_3_Wt7","fileDetails":"_1AFLk","fileName":"_3VQE8"};
var stylesheet="._1XD-V{position:relative}._3_Wt7{opacity:0;position:absolute;height:36px;width:100%;left:0;z-index:-1}._1AFLk{margin-left:16px;font-size:14px;color:#32363a}._1AFLk ._3VQE8{margin-right:16px}";
styleInject(css_248z);

export { filePickerStyles as default, stylesheet };
